// 智投
import { get, post, postParams } from './http';

//根据对外订单id获取参数信息
export function http_getInsCustomerPayArguByOutBillId(outBillId) {
    return post(`/insurance/api/insCustomerPay/getInsCustomerPayArguByOutBillId/${outBillId}`);
}

//获取订单详情
export function http_selectInsMasterBillDetails(billId) {
    return post(`/insurance/api/order/selectInsMasterBillDetails/${billId}`,);
}

//根据订单id查询被保人信息
export function http_getAllAssuredInfoByBillId(billId) {
    return post(`/insurance/api/insure/getAllAssuredInfoByBillId/${billId}`,);
}

//上传客付签名
export function http_uploadSignatureFile(data) {
    return post('/insurance/api/insCustomerPay/uploadSignatureFile', data);
}

//更新客付列表-签名
export function http_updateInsCustomerPay(data) {
    return post('/insurance/api/insCustomerPay/updateInsCustomerPay', data);
}